/**
 * 滚动进场动画 —— 从 NavBar.tsx 搬出来。
 *
 * 一个文件里既导出组件又导出 hook, React Fast Refresh 就无法只热替换组件
 * (react-refresh/only-export-components)。而 `npm run lint` 设了 --max-warnings 0,
 * 于是这一条 warning 让整个 lint 判据【长期是红的】—— 判据一直红着, 等于没有判据。
 */
import { useEffect } from 'react';

export function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}
